import { FC } from 'react'
import { IInvestmentBase } from '../../../types'
import { getUserAvatar, getCompanyLogo } from '../../../utils'
import { Avatar } from '../../atoms/Avatar'
import { TooltipContainer } from '../TooltipContainer'
import styles from './index.module.scss'

type Props = {
  receivedInvestment: IInvestmentBase
}

export const ReceivedInvestmentTooltip: FC<Props> = ({ receivedInvestment }) => {
  const name = receivedInvestment.angel ? receivedInvestment.angel.name : receivedInvestment.companyInvestedFrom.name
  const src = receivedInvestment.angel
    ? getUserAvatar(receivedInvestment.angel)
    : getCompanyLogo(receivedInvestment.companyInvestedFrom)
  return (
    <>
      <TooltipContainer text={name}>
        <div className={styles.avatar}>
          <Avatar src={src} alt={name} />
        </div>
      </TooltipContainer>
    </>
  )
}
